import React, { useEffect } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { useSsoLoginMutation } from "shared/redux/endpoints/auth"
import { ToastUtil } from "utilities/toastUtil"
import queryString from "query-string"
import { logOut } from "shared/redux/slices/authSlice"
import { useDispatch } from "react-redux"

export const SSO_REDIRECT_KEY = "ssoRedirectTo"

const RedirectToken = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const token = searchParams.get("token")
  const reduxDispatch = useDispatch()

  const [triggerSSOLogin] = useSsoLoginMutation()

  useEffect(() => {
    if (!token) {
      navigate("/login", { replace: true })
      return
    }
    reduxDispatch(logOut())

    const loginByRedirectToken = async () => {
      try {
        triggerSSOLogin({
          token,
        }).then((result) => {
          if (result.data) {
            if (result.data?.data?.user?.firstLogin)
              navigate("/change-password")
            else {
              // Google SSO round-trips through the backend, which drops our query string.
              const redirectTo = queryString.parse(location.search).redirectTo ?? sessionStorage.getItem(SSO_REDIRECT_KEY)
              sessionStorage.removeItem(SSO_REDIRECT_KEY)
              navigate(redirectTo == null ? "/" : `/${redirectTo}`, { replace: true })
            }

          } else {
            ToastUtil.showToastError(
              "Oops! Did you mistype? Or you might have changed your password and it's slipped your mind? A quick reset should do the trick!"
            )
            navigate("/", { replace: true })
          }
        })
      } catch (err) {
        // Fail -> về login
        console.log(err, "err")

        navigate("/login", { replace: true })
      }
    }

    loginByRedirectToken()
  }, [navigate, searchParams])

  return <div></div>
}

export default RedirectToken
